import Vue from 'vue'
import VueScreen from 'vue-screen'

Vue.use(VueScreen, {
  xs: 600,
  sm: 1024,
  md: 1440,
  lg: 1920,
  xl: Infinity
})
